{
  "delete": "Effacer",
  "comment": "Commentair",
  "order": "Ordre",
  "upload_date": "Date d'upload",
  "tags": "Tags",
  "image_not_found": "Image not found",
  "audio_file": "audio file",
  "field_required": "Ce champs est obligatoire",
  "open_on_tab": "Ouvrir dans un onglet"
}
